import type { LucideIcon } from 'lucide-react';
import { ArrowDownIcon, ArrowUpDownIcon, ArrowUpIcon } from 'lucide-react';

export type AcuitySelectValue = 'HIGH' | 'LOW' | 'UNASSIGNED';

type AcuityTagOption = {
    label: string;
    icon: LucideIcon;
    iconClassName: string;
};

export const ACUITY_TAG_OPTIONS: Record<AcuitySelectValue, AcuityTagOption> = {
    HIGH: { label: 'High Acuity', icon: ArrowUpIcon, iconClassName: 'text-destructive' },
    LOW: { label: 'Low Acuity', icon: ArrowDownIcon, iconClassName: 'text-secondary' },
    UNASSIGNED: {
        label: 'Assign Acuity',
        icon: ArrowUpDownIcon,
        iconClassName: 'text-muted-foreground',
    },
};

type AcuityMenuOption = AcuityTagOption & { value: AcuitySelectValue };

export const ACUITY_MENU_OPTIONS: AcuityMenuOption[] = [
    { value: 'HIGH', label: 'High acuity', icon: ArrowUpIcon, iconClassName: 'text-destructive' },
    { value: 'LOW', label: 'Low acuity', icon: ArrowDownIcon, iconClassName: 'text-secondary' },
    {
        value: 'UNASSIGNED',
        label: 'Unassign acuity',
        icon: ArrowUpDownIcon,
        iconClassName: 'text-muted-foreground',
    },
];
